import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { ShBadgeComponent } from '@gbr-monorepo/gbr-shui';
import { TranslateModule } from '@ngx-translate/core';
import { ApplicationStatus } from '@gbr-monorepo/interfaces';

@Component({
    selector: 'app-application-status-badge',
    imports: [ShBadgeComponent, TranslateModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './application-status-badge.component.html'
})
export class ApplicationStatusBadgeComponent {
    public readonly status = input.required<ApplicationStatus>();
    public readonly size = input<'small' | 'medium'>('medium');
    public readonly translationKeyPrefix = input<string>('application.status.');
    public readonly applicationStatusColors: Record<ApplicationStatus, string> = {
        [ApplicationStatus.DRAFT]: 'rgb(var(--functional-yellow))',
        [ApplicationStatus.SUBMITTED]: 'rgb(var(--ui-0))',
        [ApplicationStatus.APPROVED]: 'rgb(var(--functional-green))',
        [ApplicationStatus.DECLINED]: 'rgb(var(--functional-red))',
        [ApplicationStatus.CANCELED]: 'rgb(var(--functional-red))'
    };

    protected readonly color = computed((): string => {
        return this.applicationStatusColors[this.status()];
    });

    protected readonly label = computed((): string => {
        return `${this.translationKeyPrefix()}${this.status()}`;
    });
}
